<template>
  <div class="wrapper">
    <!-- 账号信息 -->
    <div class="user white_box">
      <div class="row">
        <div class="user_pic">
          <div class="pic">
            <img :src="my_pic" alt />
          </div>
          <div class="modify_pic pointer" @click="edit_pic()">
            <img src="@/assets/icons/edit@2x.png" alt />
          </div>
        </div>
        <div class="user-info">
          <p class="font_16_black title">账号密码</p>
          <div class="key-value">
            <div class="key">
              <p class="font_14_gray">用户名</p>
            </div>
            <div class="value">
              <p class="font_16_black">{{data.userName}}</p>
            </div>
          </div>
          <div class="key-value">
            <div class="key">
              <p class="font_14_gray">密码</p>
            </div>
            <div class="value row">
              <div style="margin-right: 120px;">
                <p class="font_16_black">* * * * * * * * * * * *</p>
                <p class="row">
                  <span class="password-strong font_14_darkgray">当前密码强度：</span>
                  <img class="icon" src="@/assets/icons/weak@2x.png" alt />
                  <img
                    v-show="passwordStep > 1"
                    class="icon"
                    src="@/assets/icons/secondary@2x.png"
                    alt
                  />
                  <img
                    v-show="passwordStep > 2"
                    class="icon"
                    src="@/assets/icons/strong@2x.png"
                    alt
                  />
                  <span
                    class="password-strong-adjust font_14_darkgray"
                  >{{data.passwordStrengthName}}</span>
                </p>
                <p class="font_14_lightgray">请妥善保管您的密码，并定期修改密码提高账号安全系数</p>
              </div>
              <button-a color="#f26828" class="query" @click.native="edit_password()">修改</button-a>
            </div>
          </div>
          <div class="key-value" style="justify-content: flex-start;">
            <div class="key">
              <p class="font_14_gray">安全验证邮箱</p>
            </div>
            <div class="value" style="flex: none; margin-right: 50px">
              <p class="font_16_black font_16_black">{{emailScrect}}</p>
              <p class="font_14_lightgray">请妥善保管邮箱的账号密码，确保收到系统邮件。如需帮助，请联系客服人员。</p>
            </div>
            <div class="row">
              <button-a color="#f26828" class="query" @click.native="edit_email()">修改</button-a>
            </div>
          </div>
          <div class="key-value" style="justify-content: flex-start;">
            <div class="key">
              <p class="font_14_gray">微信绑定</p>
            </div>
            <div class="value" style="flex: none; margin-right: 50px">
              <p class="font_16_black font_16_black">{{isBindWeChat ? '已绑定' : '未绑定'}}</p>
              <p class="font_14_lightgray">绑定微信后，可使用微信扫码快捷登录系统。</p>
            </div>
            <div class="row">
              <button-a color="#f26828" @click.native="handleWeChatAction()" class="query">{{isBindWeChat ? '解绑' : '绑定'}}</button-a>
            </div>
           </div>
        </div>
      </div>
    </div>
    <!-- 登录记录 -->
    <div class="white_box login-info">
      <p class="font_16_black title">登录信息</p>

      <div class="row table-header">
        <div class="time font_14_gray">登录时间</div>
        <div class="ip font_14_gray">ip 地址</div>
        <div class="location font_14_gray">登录地点</div>
      </div>
      <div
        class="row"
        v-for="item in record"
        :class="record-item"
        :key="record.findIndex((value)=>value === item)"
      >
        <div class="time row font_14_gray">
          <p class="time-text">{{formattedDate(item.loginTime)}}</p>
          <!-- <div class="tag-group row">
            <tag class="tag" color="#08a752" bgcolor="#e1ffe8" bdcolor="#08a752" name="最新" />
            <tag class="tag" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" name="在职" />
            <tag class="tag" color="#f26828" bgcolor="#fdf0ea" bdcolor="#f26828" name="第一次" />
          </div>-->
        </div>
        <div class="ip font_14_gray">{{item.loginIP}}</div>
        <div class="location font_14_gray">{{item.loginAddress}}</div>
      </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog title :visible.sync="edit_psw_mask" @close="close" width="28%" center>
      <h3 class="export-title font_16_black">修改密码</h3>
      <div class="export-item">
        <p class="export-item-name font_14_black">原密码</p>
        <el-input
          show-password
          class="custom-es"
          size="medium"
          placeholder="请输入原密码"
          v-model="password"
          clearable
        ></el-input>
        <div class="tip_icons">
          <img v-if="errInput.password" class="tip_icon" src="@/assets/icons/x005-E004@2x.png" alt />
          <img
            v-else-if="crtInput.password"
            class="tip_icon"
            src="@/assets/icons/check002-E007@2x.png"
            alt
          />
        </div>
        <div class="tip">
          <p class="font_12_red">{{tip01}}</p>
        </div>
      </div>
      <div class="export-item">
        <p class="export-item-name font_14_black">新密码</p>
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入新密码"
          v-model="new_password"
          clearable
          show-password
        ></el-input>
        <div class="tip_icons">
          <img
            v-if="errInput.new_password"
            class="tip_icon"
            src="@/assets/icons/x005-E004@2x.png"
            alt
          />
          <img
            v-else-if="crtInput.new_password"
            class="tip_icon"
            src="@/assets/icons/check002-E007@2x.png"
            alt
          />
        </div>
      </div>
      <div class="export-item" style="position: relative">
        <p class="export-item-name font_14_black">新密码</p>
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请再次输入新密码"
          v-model="new_password_again"
          clearable
          show-password
        ></el-input>
        <div class="tip_icons">
          <img
            v-if="errInput.new_password_again"
            class="tip_icon"
            src="@/assets/icons/x005-E004@2x.png"
            alt
          />
          <img
            v-else-if="crtInput.new_password_again"
            class="tip_icon"
            src="@/assets/icons/check002-E007@2x.png"
            alt
          />
        </div>
        <div class="tip">
          <p class="font_12_red">{{tip02}}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            :disabled="button_disabled"
            padding="0.52vw 6.6vw"
            color="#fff"
            bgcolor="#f26828"
            @click.native="saveNewPassword()"
          >保存</button-a>
        </div>
      </span>
    </el-dialog>
    <!-- 修改邮箱 -->
    <el-dialog title :visible.sync="edit_email_mask" @close="close" width="30%" center>
      <h3 class="export-title font_16_black">修改邮箱</h3>
      <div class="export-item this-page">
        <p class="export-item-name font_14_black">新邮箱</p>
        <el-input class="custom-es" size="medium" placeholder="请输入新邮箱" v-model="email" clearable></el-input>
        <div class="get_code">
          <p class="font_14_blue get-code" v-show="!waitting" @click="get_email_code()">获取验证码</p>
          <p class="font_14_darkgray get-code" v-show="waitting">验证码已发送({{seconds}}s)</p>
        </div>
        <div class="tip">
          <p class="font_12_red">{{tip11}}</p>
        </div>
      </div>
      <div class="export-item this-page">
        <p class="export-item-name font_14_black">验证码</p>
        <el-input
          class="custom-es"
          size="medium"
          placeholder="请输入验证码"
          v-model="email_code"
          clearable
        ></el-input>
        <div class="tip">
          <p class="font_12_red">{{tip12}}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            :disabled="button_disabled"
            padding="0.52vw 6.6vw"
            color="#fff"
            bgcolor="#f26828"
            @click.native="seveNewEmail()"
          >保存</button-a>
        </div>
      </span>
    </el-dialog>
    <!-- 修改头像 -->
    <el-dialog title :visible.sync="edit_pic_mask" @close="close" width="23%" center>
      <h3 class="export-title font_16_black">修改头像</h3>
      <el-upload
        ref="upload"
        class="upload"
        show-file-list
        :file-list="fileList"
        :limit="1"
        :auto-upload="false"
        :before-upload="beforeUpload"
        :action="upload_url"
        :headers="headers"
        :on-success="upload_ok"
        accept=".jpg, .jpeg, .png"
      >
        <div class="upload">
          <el-button size="small" type="primary">选择图片</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            :disabled="button_disabled"
            padding="0.52vw 6.6vw"
            color="#fff"
            bgcolor="#f26828"
            @click.native="savePic()"
          >保存</button-a>
        </div>
      </span>
    </el-dialog>
    <!-- 操作成功 -->
    <el-dialog title :visible.sync="success_mask" @close="close" width="320px" center>
      <div class="success_icon">
        <img class="success-icon" src="@/assets/icons/check002-E007@2x.png" alt />
      </div>
      <h3 class="export-title font_16_black" style="margin-bottom: 0;">修改成功</h3>
      <span slot="footer" class="dialog-footer">
        <div class="save_btn">
          <button-a
            padding="0.52vw 2.8vw"
            color="#fff"
            bgcolor="#f26828"
            @click.native="success_mask = false"
          >确定</button-a>
        </div>
      </span>
    </el-dialog>
    <!-- 微信绑定 -->
    <el-dialog :show-close="false" :visible.sync="wechat_qr_mask" :close-on-click-modal="false" :close-on-press-escape="false" width="360px" center>
      <div class="wechat-dialog-header">
        <h3 class="export-title font_16_black">微信绑定</h3>
        <i class="el-icon-close wechat-close-btn" @click="closeWeChatDialog"></i>
      </div>
      <div class="wechat-qrcode-box">
        <img
          v-if="wechat_qrcode_url && !showRefreshBtn"
          class="wechat-qrcode-image"
          :src="wechat_qrcode_url"
          alt="wechat-qrcode"
        />
        <p v-else-if="showRefreshBtn" class="font_14_darkgray wechat-tip">请刷新二维码后重新扫码</p>
        <p v-else class="font_14_darkgray wechat-tip">二维码加载中...</p>
        <p class="font_14_darkgray wechat-tip">{{wechat_status_text}}</p>
        <p v-if="wechat_error_text" class="font_12_red wechat-error">{{wechat_error_text}}</p>
      </div>
      <div v-if="showRefreshBtn" class="wechat-refresh-box">
        <button-a color="#fff" bgcolor="#f26828" @click.native="refreshWeChatQrcode">刷新二维码</button-a>
      </div>
    </el-dialog>
    <!-- 解绑确认 -->
    <el-dialog title :visible.sync="unbindConfirmDialog" width="420px" center>
      <div class="confirm-content">
        <div class="confirm-header">
          <span class="exclamation-icon">!</span>
          <span class="confirm-title">解除绑定确认</span>
        </div>
        <p class="confirm-desc">解绑绑定后，无法扫码登录，是否继续</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="unbindConfirmDialog = false">取消</el-button>
        <el-button class="confirm-btn" type="primary" @click="confirmUnbindWeChat">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Get, Post, Put } from "../../js/http.js";
import { dateConvert, getToken, limitUpload } from "../../js/tool.js";
import { Message } from "element-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      data: {
        userName: "",
        profile: "",
        passwordStrengthName: "",
        email: "",
        isBindWeChat:null
      },
      record: [],
      fileList: [],
      edit_pic_mask: false, // 修改头像遮罩
      edit_psw_mask: false, // 修改密码遮罩
      edit_email_mask: false, // 修改邮箱遮罩
      success_mask: false, // 操作成功遮罩

      button_disabled: false,

      password: "", // 原密码
      new_password: "", // 新密码
      new_password_again: "", // 再次输入新密码
      tip01: "",
      tip02: "",

      email: "", // 新邮箱
      seconds: 0, // 获取验证码倒计时
      email_code: "", // 邮箱验证码
      tip11: "",
      tip12: "",
   isBindWeChat:null, // 是否绑定微信
      wechat_qr_mask: false, // 微信绑定二维码弹窗
      wechat_qrcode_url: "", // 微信二维码地址
      wechat_session_key: "", // 微信二维码会话key
      wechat_status_text: "请使用微信扫描二维码",
      wechat_error_text: "",
      wechat_poll_count: 0,
      wechat_poll_timer: null,
      showRefreshBtn: false, // 是否显示刷新按钮
      unbindConfirmDialog: false, // 解绑确认弹窗
      errInput: {}, // 错误输入标记
      crtInput: {}, // 正确输入标记

      headers: {
        Authorization: "Bearer " + getToken(),
        "X-Fanyun-api-version": process.env.VUE_APP_VERSION
      }
    };
  },
  watch: {},
  computed: {
    user_pic() {
      return this.$store.state.user_pic;
    },
     my_pic() {
      return this.$store.state.my_pic;
     },
    // 等待获取验证码
    waitting() {
      return this.seconds > 0;
    },
    // 密码强度
    passwordStep() {
      if (this.data.passwordStrengthName === "强") return 3;
      if (this.data.passwordStrengthName === "中") return 2;
      return 1;
    },
    // 邮箱混淆*号
    emailScrect() {
      let email = this.data.email;
      return email.replace(email.substring(2, 5), "***");
    },
    // 头像上传url
    upload_url() {
      return process.env.VUE_APP_APIROOT + "/api/v1/accounts/me/avatar";
    }
  },
  methods: {
    // 账号信息
    getData() {
      Get("api/v1/accounts/me").then(res => {
        this.data = res.data;
        console.log(res.data)
        this.isBindWeChat = res.data.isBindWeChat;
      });
    },
    // 获取头像方法，用于上传头像后更新头像
    getPic() {
      Get(
        "api/v1/accounts/me/avatar",
        // {
        //   responseType: "arraybuffer"
        // },
        {}
      )
        // .then(res => {
        //   return (
        //     "data:image/png;base64," +
        //     btoa(
        //       new Uint8Array(res.data).reduce(
        //         (data, byte) => data + String.fromCharCode(byte),
        //         ""
        //       )
        //     )
        //   );
        // })
        .then(res => {
          if(res.data){
          const avatarData = `data:${res.msg};base64,${res.data}`;
          localStorage.setItem('my_pic', avatarData);
          this.$store.commit("my_pic", avatarData);
          }else{
            this.$store.commit("my_pic", require('@/assets/header.png'));
          }
        }).catch(() => {
          this.$store.commit("my_pic", require('@/assets/header.png'));
        });
    },
    // 登录记录
    getRecord() {
      Get("api/v1/accounts/me/logins").then(res => {
        this.record = res.data;
      });
    },
    // 登录日期格式
    formattedDate(date) {
      return dateConvert(date, {
        format: "Y-M-D H:MIN:S"
      });
    },
    // 点击上传头像按钮
    edit_pic() {
      this.edit_pic_mask = true;
    },
    // 点击修改密码按钮
    edit_password() {
      this.edit_psw_mask = true;
    },
    // 点击修改邮箱按钮
    edit_email() {
      this.edit_email_mask = true;
    },
    // 清空输入
    clearValue(list) {
      list.map(name => {
        this[name] = "";
      });
    },
    // 保存新密码
    saveNewPassword() {
      // 输入验证
      let errInput = {
        password: false,
        new_password: false,
        new_password_again: false
      };

      this.password = this.password.trim();
      this.new_password = this.new_password.trim();
      this.new_password_again = this.new_password_again.trim();

      if (this.password === "") {
        errInput.password = true;
        this.tip01 = "输入错误";
      } else {
        this.tip01 = "";
      }
      if (this.new_password === "") errInput.new_password = true;
      if (this.new_password_again === "") errInput.new_password_again = true;
      if (this.new_password_again !== this.new_password) {
        errInput.new_password = true;
        errInput.new_password_again = true;
        this.tip02 = "新密码输入不一致!";
      } else {
        this.tip02 = "";
      }
      this.errInput = errInput;
      this.crtInput = {
        password: true,
        new_password: true,
        new_password_again: true
      };
      for (let key in errInput) {
        if (errInput[key]) {
          return false;
        }
      }

      this.button_disabled = true;
      Put("api/v1/accounts/me/password", {
        oldPassword: this.password,
        newPassword: this.new_password
        })
        .then(() => {
          this.button_disabled = false;
          this.clearValue([
            "password",
            "new_password",
            "new_password_again",
            "errInput",
            "crtInput",
            "email",
            "email_code"
          ]);

          this.edit_psw_mask = false;
          this.success_mask = true;
        })
        .catch(err => {
          this.tip01 = err.msg;
          this.clearValue(["errInput", "crtInput"]);
          this.button_disabled = false;
        });
    },
    // 获取邮箱验证码
    get_email_code() {
      if (this.email === "") {
        this.tip11 = "请输入邮箱";
        return false;
      }
      this.clearValue(["tip11"]);
      Post("api/v1/accounts/me/email/change", {
        newEmail: this.email
      }).then(res => {
        if (res.isSuccess) {
          this.uuid = res.data;
          this.seconds = 60;
          this.countDown("seconds");
        }
      });
    },
    // 倒计时
    countDown(time) {
      this[time]--;
      if (this[time] > 0) {
        // 保存定时器
        this.timer = setTimeout(() => {
          this.countDown(time);
        }, 1000);
      }
    },
    // 保存新邮箱
    seveNewEmail() {
      if (this.email_code === "") {
        this.tip11 = "请输入邮箱";
      } else if (this.code === "") {
        this.tip12 = "请输入验证码";
        return false;
      }

      this.clearValue(["tip11", "tip12"]);
      this.button_disabled = true;
      Put("api/v1/accounts/me/email", {
        newEmail: this.email,
         uuid: this.uuid,
        verificationCode: this.email_code
      })
        .then(() => {
          this.button_disabled = false;
          this.edit_email_mask = false;
          this.success_mask = true;
        })
        .catch(() => {
          this.button_disabled = false;
        });
    },
    // 确定新头像
    savePic() {
      this.$refs.upload.submit();
    },
    beforeUpload(file) {
      let isOk = limitUpload(file, 1);
      if (!isOk) {
        Message.error({
          customClass: "top-layer",
          message: "文件大小超过1M"
        });
      }
      return isOk;
    },
    // 上传成功
    upload_ok(res) {
      if (res.isSuccess) {
        this.edit_pic_mask = false;
        this.success_mask = true;
        this.getPic();
      } else {
        Message.error({
          customClass: "top-layer",
          message: res.msg
        });
      }
      this.$refs.upload.clearFiles(); // 上传成功或失败都清空文件
    },
    // 关闭遮罩恢复按钮
    close() {
      this.button_disabled = false;
      this.clearValue([
        "password",
        "new_password",
        "new_password_again",
        "errInput",
        "crtInput",
        "email",
        "email_code",
        "tip01",
        "tip02",
        "tip11",
        "tip12",
      ]);
    },
    handleWeChatAction() {
      if (this.isBindWeChat) {
        this.unbindConfirmDialog = true;
        return;
      }
      this.openWeChatDialog();
    },
    openWeChatDialog() {
      this.wechat_qr_mask = true;
      this.refreshWeChatQrcode();
    },
    closeWeChatDialog() {
      this.stopWeChatPolling();
      this.wechat_qr_mask = false;
      this.wechat_qrcode_url = "";
      this.wechat_session_key = "";
      this.wechat_status_text = "请使用微信扫描二维码";
      this.wechat_error_text = "";
      this.showRefreshBtn = false;
    },
    refreshWeChatQrcode() {
      this.stopWeChatPolling();
      this.wechat_qrcode_url = "";
      this.wechat_session_key = "";
      this.wechat_status_text = "二维码加载中...";
      this.wechat_error_text = "";
      this.showRefreshBtn = false;

      Post("api/v1/wechat/qrcodes", {})
        .then(res => {
          const payload = res.data || {};
          this.wechat_session_key = payload.sessionKey || payload.SessionKey || "";
          this.wechat_qrcode_url =
            payload.qrcodeUrl || payload.qrCodeUrl || payload.qrcode || payload.url || "";

          if (!this.wechat_session_key || !this.wechat_qrcode_url) {
            this.wechat_status_text = "二维码生成失败";
            return;
          }
          this.wechat_status_text = "请使用微信扫码";
          this.pollWeChatQrcodeStatus();
        })
        .catch(err => {
          this.wechat_status_text =  err.msg || "二维码生成失败";
        });
    },
    stopWeChatPolling() {
      if (this.wechat_poll_timer) {
        clearTimeout(this.wechat_poll_timer);
        this.wechat_poll_timer = null;
      }
    },
    scheduleWeChatPolling() {
      this.stopWeChatPolling();
      this.wechat_poll_timer = setTimeout(() => {
        this.pollWeChatQrcodeStatus();
      }, 3000);
    },
    pollWeChatQrcodeStatus() {
      if (!this.wechat_qr_mask || !this.wechat_session_key) return;
      Get(`api/v1/wechat/qrcodes/${this.wechat_session_key}/status`)
        .then(res => {
          const status = res.msg

          if (status === "Pending") {
            this.scheduleWeChatPolling();
            return;
          }

          if (status === "Unbound") {
            this.bindCurrentAccountWeChat();
            return;
          }

          if (status === "Bound") {
            this.stopWeChatPolling();
            this.wechat_error_text = "该微信账号已绑定其他账号";
            this.wechat_status_text = "绑定失败";
            this.showRefreshBtn = true;
            return;
          }

          if (status === "Expired") {
            this.refreshWeChatQrcode();
            return;
          }

          this.wechat_status_text = "等待扫码...";
          this.scheduleWeChatPolling();
        })
        .catch(() => {
          this.scheduleWeChatPolling();
        });
    },
    //登录验证
    wechatLogin(){
      Post(`api/v1/auth/wechat/login`, {
        sessionKey: this.wechat_session_key
      })
        .then(res => {
          if(res.isSuccess){
             console.log(res)
            this.bindCurrentAccountWeChat()
         }
        })
        .catch((res) => {
             console.log(res)
        //  this.scheduleWeChatPolling();
        });
    },
    //登录账号绑定微信
     wechatbind(){
      Post(`api/v1/auth/wechat/bind`, {
        password: localStorage.getItem('password') ,
        userName: this.data.userName,
        sessionKey: this.wechat_session_key
      })
        .then(res => {
         if(res.isSuccess){
            console.log(res)
            this.wechatLogin()
         }
        })
        .catch(() => {
        //  this.scheduleWeChatPolling();
        });
    },
    bindCurrentAccountWeChat() {
      if (!this.wechat_session_key) {
        console.log('bindCurrentAccountWeChat: sessionKey为空');
        this.wechat_error_text = "会话已过期，请刷新重试";
        this.wechat_status_text = "绑定失败";
        this.showRefreshBtn = true;
        return;
      }

      this.stopWeChatPolling();
      this.wechat_status_text = "正在绑定...";
      console.log('bindCurrentAccountWeChat: 开始绑定, sessionKey:', this.wechat_session_key);
      
      Post("api/v1/accounts/me/wechat", {
        sessionKey: this.wechat_session_key
      })
        .then(res => {
          console.log('bindCurrentAccountWeChat: 绑定成功', res);
          this.showRefreshBtn = false;
          this.closeWeChatDialog();
          this.success_mask = true;
          this.isBindWeChat = true;
          this.getData();
        })
        .catch(err => {
          console.log('bindCurrentAccountWeChat: 绑定失败', err);
          this.wechat_error_text = err.msg || "绑定失败，请重试";
          this.wechat_status_text = "绑定失败";
          this.showRefreshBtn = true;
        });
    },
    
    unbindWeChat() {
      Post("api/v1/accounts/me/wechat/unbind", {})
        .then(() => {
          this.success_mask = true;
          this.isBindWeChat = false;
          this.getData();
        })
        .catch(err => {
          Message.error({
            customClass: "top-layer",
            message: err.msg || "解绑失败，请稍后重试"
          });
        });
    },
    confirmUnbindWeChat() {
      this.unbindConfirmDialog = false;
      this.unbindWeChat();
    }
  },
  created() {},
  beforeDestroy() {
    this.stopWeChatPolling();
  },
  mounted() {
    this.getData();
    //this.getPic();
    this.getRecord();
  }
};
</script>
<style lang="scss" scoped>
// 布局样式
.wrapper {
  padding: 32px 32px 24px;
  > div {
    padding: 80px 0 80px 144px;
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-dialog__wrapper {
    padding: 0;
    margin: 0;
  }
  .user {
    .title {
      height: auto;
      margin-bottom: 30px;
    }
    > .row {
      align-items: flex-start;
    }
  }
  .user_pic {
    margin-right: 58px;
  }
  .user-info {
    flex: 1;
    .password-strong {
      margin-right: 12px;
    }
    // 密码强度图标
    .icon {
      width: 50px;
      height: 10px;
      margin-right: 2px;
    }
    .password-strong-adjust {
      margin-left: 10px;
    }
  }
  .login-info {
    .title {
      height: auto;
      margin-bottom: 32px;
    }
    > .row {
      width: 721px;
      padding: 10px 0 10px 25px;
    }
    .table-header {
      background-color: #fafbff;
      border-radius: 8px;
    }
    .time {
      align-self: stretch;
      width: 380px;
      .time-text {
        white-space: nowrap;
      }
      .tag-group {
        flex-wrap: wrap;
      }
      .tag {
        margin-bottom: 2px;
        margin-right: 2px;
      }
    }
    .ip {
      width: 200px;
    }
    .location {
      flex: 1;
    }
  }
}
// 键值对
.key-value {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // align-self: stretch;
  margin-right: 150px;
  padding-bottom: 54px;
  &:last-child {
    margin-right: 0;
    padding-bottom: 0;
  }
  .key {
    width: 90px;
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  .value {
    flex: 1;
  }
  p {
    margin-bottom: 16px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.export-item {
  position: relative;
}
.export-item.this-page {
  padding-left: 50px;
  justify-content: flex-start;
}
.get_code {
  margin-left: 4px;
}
.save_btn {
  padding-top: 30px;
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tip {
  position: absolute;
  left: 136px;
  bottom: -16px;
}
.tip_icons {
  position: relative;
  width: 20px;
  height: 20px;
  overflow: hidden;
  margin-left: 24px;
  .tip_icon {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.success_icon {
  display: flex;
  justify-content: center;
  img {
    width: 40px;
    height: 40px;
  }
}
.get-code {
  cursor: pointer;
}
.wechat-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #EBEEF5;
  .wechat-close-btn {
    cursor: pointer;
    font-size: 18px;
    color: #909399;
    transition: color 0.3s;
    &:hover {
      color: #409EFF;
    }
  }
  .export-title {
    margin: 0;
    line-height: 1.2;
  }
}
.wechat-qrcode-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  .wechat-qrcode-image {
    width: 220px;
    height: 220px;
    margin-bottom: 16px;
  }
  .wechat-tip {
    margin-bottom: 8px;
    font-size: 14px;
    color: #606266;
  }
  .wechat-error {
    margin-bottom: 24px;
    color: #F56C6C;
  }
}
.wechat-refresh-box {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 8px;
}

// 调整微信绑定弹窗的样式
::v-deep .el-dialog {
  .el-dialog__header {
    padding: 15px 20px 10px;
  }
  .el-dialog__body {
    padding: 0 20px 20px;
  }
}

.confirm-content {
  padding: 20px 0;
  
  .confirm-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    
    .exclamation-icon {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f56c6c;
      color: white;
      font-size: 16px;
      font-weight: bold;
      border-radius: 50%;
      margin-right: 8px;
    }
    
    .confirm-title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
  }
  
  .confirm-desc {
    font-size: 14px;
    color: #606266;
    line-height: 1.5;
  }
}

.cancel-btn {
  margin-right: 12px;
  padding: 8px 32px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #606266;
  
  &:hover {
    background-color: #e8eaed;
    border-color: #d4d7de;
  }
}

.confirm-btn {
  padding: 8px 32px;
  background-color: #f26828;
  border-color: #f26828;
  
  &:hover {
    background-color: #f47c40;
    border-color: #f47c40;
  }
}
</style>